document.addEventListener('DOMContentLoaded', function() {
  fetch('https://sheetdb.io/api/v1/j61z3yvcyw9eu?sheet=Orbimax (PARTNER SITE)')
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      
      document.querySelector('.easy-rate').textContent = data[0]['From - Comparison Rate'];
      document.querySelector('.easy-terms').innerHTML = data[0]['Terms Popup'].replace('RATE%', data[0]['From - Comparison Rate']);

      populateEasyWrapperCollection();
    });
  
  function populateEasyWrapperCollection() {
     
      var easyRate = document.querySelector('.easy-rate').textContent;
      var compRate = easyRate.replace('%', '');
      var easyTerms = document.querySelector('.easy-terms').textContent;
      var LoanTerm = 5;
       
      var gridElements = document.querySelectorAll('.js-grid');
      var slideElements = document.querySelectorAll('.collection-tabs');
      const currentUrl = window.location.href;
    
      gridElements.forEach(function(element) {
        var gridItems = element.querySelectorAll('.product__grid__info');
        gridItems.forEach(function(item) {
          //var priceElements = item.querySelector('.price').textContent.trim().replace(/[^0-9\.]+/g, '');
          var priceElement = item.querySelector('.product__grid__price span:first-child');
          var priceText = priceElement.textContent.trim().replace(/[^0-9\.]+/g, '');
          var priceOrig = item.querySelector('.price');
          var priceFrom = item.querySelector('.price').textContent;
          var assetPrice = priceText.replace(/\.00$/,'');
          var productName = item.querySelector('.product__grid__title').textContent;
          // Remove spaces from the product name
          var productNameWithoutSpaces = productName.replace(/\s+/g, '');
          var productLink = item.querySelector('.product__grid__info > a').href;
          if (assetPrice > 5000 && !priceFrom.includes('From')) {
            priceOrig.style.display = 'none';
            var assetPriceDeposit = assetPrice - (assetPrice * 0.20);
            var totalPercent = (compRate * LoanTerm) / 100;
            var totalRepay = Math.floor((assetPriceDeposit * 1 + assetPriceDeposit * totalPercent) / (52.1429 * LoanTerm));
             
            var easyWrapper = document.createElement('div');
            easyWrapper.classList.add('easy-wrapper');
            easyWrapper.style.marginTop = '10px';
            var easyImg = document.createElement('div');
            easyImg.classList.add('easy-img');
            var img = document.createElement('img');
            img.setAttribute('src', 'https://fast-quote.jade.finance/wp-content/uploads/Jade-Equipment-Finance.svg');
            img.style.width = '40px';
            var a = document.createElement('a');
            if(currentUrl == 'https://www.orbimax.com.au/'){
              a.setAttribute('href', `${productLink}`);
            }else{
              a.setAttribute('href', `${productLink}`);
            }
            a.setAttribute('target', '_blank');
            
            var price = document.createElement('span');
            price.textContent = item.querySelector('.price').textContent;
            a.appendChild(price);
            //a.appendChild(img);
            
            easyImg.appendChild(a);
            var easyPriceWrap = document.createElement('div');
            easyPriceWrap.classList.add('easy-price-wrap');
            var small = document.createElement('small');
            small.textContent = 'Finance From ';
            var easyLink = document.createElement('div');
            easyLink.classList.add('easy-link');
            var ecfInfoIcon = document.createElement('img');
            ecfInfoIcon.setAttribute('src', 'https://fast-quote.jade.finance/wp-content/uploads/ecf-info-icon-inverse.webp');
            ecfInfoIcon.setAttribute('title', 'Terms and Conditions apply. Click here to learn more.');
            var weeklyAmount = document.createElement('span');
            weeklyAmount.classList.add('ecf-weekly-amount');
            weeklyAmount.textContent = totalRepay;
            var frequency = document.createElement('span');
            frequency.classList.add('easy-frequency');
            frequency.textContent = 'per week';
            var link = document.createElement('a');
            if(currentUrl == 'https://www.orbimax.com.au/'){
              link.setAttribute('href', `${productLink}`);
            }else{
              link.setAttribute('href', `${productLink}`);
            }
            link.setAttribute('target', '_blank');
            link.appendChild(document.createTextNode('$'));
            link.appendChild(weeklyAmount);
            link.appendChild(document.createTextNode(' '));
            link.appendChild(frequency);
            easyLink.appendChild(ecfInfoIcon);
            easyPriceWrap.appendChild(small);
            easyPriceWrap.appendChild(easyLink);
            easyPriceWrap.appendChild(link);
            easyWrapper.appendChild(easyImg);
            easyWrapper.appendChild(easyPriceWrap);

            var afterGrid = item.querySelector('.product__grid__price');
            afterGrid.appendChild(easyWrapper);

            //if (priceOrig.includes('From')) {
                //var css = '.collection__products .product__grid__price span.price, .homepage-collection .product__grid__price span.price { display: none; } .easy-img span{display: block;}';
                //var style = document.createElement('style');
               // style.appendChild(document.createTextNode(css));
                //afterGrid.appendChild(style);
            //}
           

            var easyLink = item.querySelector('.easy-link');
            easyLink.addEventListener('click', function() {
              var easyTerms = document.querySelector('.easy-terms').textContent;
              var uEasyTerms = easyTerms.replace('RATE%', easyRate);
              alert(uEasyTerms);
            });
          }
        });
      });

    slideElements.forEach(function(element) {
        var gridItems = element.querySelectorAll('.product__grid__info');
        gridItems.forEach(function(item) {
          //var priceElements = item.querySelector('.price').textContent.trim().replace(/[^0-9\.]+/g, '');
          var priceElement = item.querySelector('.product__grid__price span:first-child');
          var priceText = priceElement.textContent.trim().replace(/[^0-9\.]+/g, '');
          var priceOrig = item.querySelector('.price');
          var priceFrom = item.querySelector('.price').textContent;
          var assetPrice = priceText.replace(/\.00$/,'');
          var productName = item.querySelector('.product__grid__title').textContent;
          // Remove spaces from the product name
          var productNameWithoutSpaces = productName.replace(/\s+/g, '');
          var productLink = item.querySelector('.product__grid__info > a').href;
          if (assetPrice > 5000 && !priceFrom.includes('From')) {
            priceOrig.style.display = 'none';
            var assetPriceDeposit = assetPrice - (assetPrice * 0.20);
            var totalPercent = (compRate * LoanTerm) / 100;
            var totalRepay = Math.floor((assetPriceDeposit * 1 + assetPriceDeposit * totalPercent) / (52.1429 * LoanTerm));
             
            var easyWrapper = document.createElement('div');
            easyWrapper.classList.add('easy-wrapper');
            easyWrapper.style.marginTop = '10px';
            var easyImg = document.createElement('div');
            easyImg.classList.add('easy-img');
            var img = document.createElement('img');
            img.setAttribute('src', 'https://fast-quote.jade.finance/wp-content/uploads/Jade-Equipment-Finance.svg');
            img.style.width = '40px';
            var a = document.createElement('a');
            if(currentUrl == 'https://www.orbimax.com.au/'){
              a.setAttribute('href', `${productLink}`);
            }else{
              a.setAttribute('href', `${productLink}`);
            }
            a.setAttribute('target', '_blank');
            
            var price = document.createElement('span');
            price.textContent = item.querySelector('.price').textContent;
            a.appendChild(price);
            //a.appendChild(img);
            
            easyImg.appendChild(a);
            var easyPriceWrap = document.createElement('div');
            easyPriceWrap.classList.add('easy-price-wrap');
            var small = document.createElement('small');
            small.textContent = 'Finance From ';
            var easyLink = document.createElement('div');
            easyLink.classList.add('easy-link');
            var ecfInfoIcon = document.createElement('img');
            ecfInfoIcon.setAttribute('src', 'https://fast-quote.jade.finance/wp-content/uploads/ecf-info-icon-inverse.webp');
            ecfInfoIcon.setAttribute('title', 'Terms and Conditions apply. Click here to learn more.');
            var weeklyAmount = document.createElement('span');
            weeklyAmount.classList.add('ecf-weekly-amount');
            weeklyAmount.textContent = totalRepay;
            var frequency = document.createElement('span');
            frequency.classList.add('easy-frequency');
            frequency.textContent = 'per week';
            var link = document.createElement('a');
            if(currentUrl == 'https://www.orbimax.com.au/'){
              link.setAttribute('href', `${productLink}`);
            }else{
              link.setAttribute('href', `${productLink}`);
            }
            link.setAttribute('target', '_blank');
            link.appendChild(document.createTextNode('$'));
            link.appendChild(weeklyAmount);
            link.appendChild(document.createTextNode(' '));
            link.appendChild(frequency);
            easyLink.appendChild(ecfInfoIcon);
            easyPriceWrap.appendChild(small);
            easyPriceWrap.appendChild(easyLink);
            easyPriceWrap.appendChild(link);
            easyWrapper.appendChild(easyImg);
            easyWrapper.appendChild(easyPriceWrap);

            var afterGrid = item.querySelector('.product__grid__price');
            afterGrid.appendChild(easyWrapper);

            //if (priceOrig.includes('From')) {
                //var css = '.collection__products .product__grid__price span.price, .homepage-collection .product__grid__price span.price { display: none; } .easy-img span{display: block;}';
                //var style = document.createElement('style');
               // style.appendChild(document.createTextNode(css));
                //afterGrid.appendChild(style);
            //}
           

            var easyLink = item.querySelector('.easy-link');
            easyLink.addEventListener('click', function() {
              var easyTerms = document.querySelector('.easy-terms').textContent;
              var uEasyTerms = easyTerms.replace('RATE%', easyRate);
              alert(uEasyTerms);
            });
          }
        });
      });
    
    }
});